import type {
  IOnboardingInitiateOrgSubmitterClaimProfileBody,
  IOnboardingInitiateOrgSubmitterClaimProfileRequest,
  IOnboardingInitiateOrgSubmitterClaimProfileResponse,
} from '@/app-package';

import axios from 'axios';

const initiateOrgSubmitterClaimProfile = async (
  body: IOnboardingInitiateOrgSubmitterClaimProfileBody,
) => {
  const url = `/onboarding/claim/org_submitter`;

  const config: IOnboardingInitiateOrgSubmitterClaimProfileRequest = {
    url,
    method: 'post',
    data: body,
  };

  const { data } =
    await axios.request<IOnboardingInitiateOrgSubmitterClaimProfileResponse>(
      config,
    );

  return data;
};

export default initiateOrgSubmitterClaimProfile;
